/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_HomeInputs */

const en_go_home = /** @type {(inputs: Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go Home`)
};

const es_go_home = /** @type {(inputs: Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al inicio`)
};

const fr_go_home = /** @type {(inputs: Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à l'accueil`)
};

const de_go_home = /** @type {(inputs: Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Startseite`)
};

const ja_go_home = /** @type {(inputs: Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホームへ戻る`)
};

const zh_go_home = /** @type {(inputs: Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首页`)
};

const ar_go_home = /** @type {(inputs: Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العودة للرئيسية`)
};

const id_go_home = /** @type {(inputs: Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke Beranda`)
};

const it_go_home = /** @type {(inputs: Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna alla Home`)
};

const ru_go_home = /** @type {(inputs: Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На главную`)
};

const pt_go_home = /** @type {(inputs: Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o Início`)
};

const ko_go_home = /** @type {(inputs: Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`홈으로 가기`)
};

/**
* | output |
* | --- |
* | "Go Home" |
*
* @param {Go_HomeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const go_home = /** @type {((inputs?: Go_HomeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_HomeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_go_home(inputs)
	if (locale === "es") return es_go_home(inputs)
	if (locale === "fr") return fr_go_home(inputs)
	if (locale === "de") return de_go_home(inputs)
	if (locale === "ja") return ja_go_home(inputs)
	if (locale === "zh") return zh_go_home(inputs)
	if (locale === "ar") return ar_go_home(inputs)
	if (locale === "id") return id_go_home(inputs)
	if (locale === "it") return it_go_home(inputs)
	if (locale === "ru") return ru_go_home(inputs)
	if (locale === "pt") return pt_go_home(inputs)
	return ko_go_home(inputs)
});